import { render, staticRenderFns } from "./VideoContentBlock.vue?vue&type=template&id=707c36b7&scoped=true&"
import script from "./VideoContentBlock.vue?vue&type=script&lang=js&"
export * from "./VideoContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./VideoContentBlock.vue?vue&type=style&index=0&id=707c36b7&lang=scss&scoped=true&"
import style1 from "./VideoContentBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c36b7",
  null
  
)

export default component.exports